<div class="breadcrumb_outer">
  <div class="breadcrumb_outer">
        <ul class="breadcrumb">
            <li>
                <a>{{ company_name }}:</a>
            </li>
            <li class="active" >
               <a (click)="goToPageLink('piezo-dashboard')">
                    Powertrain Dashboard
                </a>
            </li>
            <li class="active">
                <a (click)="goToPageLink('#')">
                    Piezo Sensor Dasboard
                </a>
            </li>
        </ul>
        <div class="right">
            <span>{{ today }}</span>
            <!--here responsiveness has been used commented by Prerna Singh on 21 february 2024-->
        </div>
    </div>
</div>

<div class="Content_outer">
  <div class="row">
    <div class="col-md-12">

      <div class="d-flex justify-content-between align-items-center border-bottom mb-3 sticky-tabs-header">

        <ul ngbNav #ctdTabset="ngbNav" class="custom_tab nav-v nav-tabs border-bottom-0 mb-0" [activeId]="active_tab_id" (navChange)="onNavChange($event)">
          <li [ngbNavItem]="'tab-1'" id="tab-1">
            <a ngbNavLink>Monitoring</a>
            <ng-template ngbNavContent>
              <app-piezeo-sensor-monitoring [data]="childComponentData" (navigateToTab)="onTabChangeRequest($event)" />
            </ng-template>
          </li>
          <li [ngbNavItem]="'tab-2'" id="tab-2">
            <a ngbNavLink>Diagnostics</a>
            <ng-template ngbNavContent>
              <app-piezo-diagnostics [data]="childComponentData" />
            </ng-template>
          </li>
          <li [ngbNavItem]="'tab-3'" *ngIf="!BHEL_ON_PREM" id="tab-3">
            <a ngbNavLink>Predictive Analytics</a>
            <ng-template ngbNavContent>
              <app-piezo-predictive [data]="childComponentData" />
            </ng-template>
          </li>
        </ul>

        <div class="d-flex align-items-center">

          <div class="status-legend d-flex align-items-center me-4">
            <div class="legend-item">
              <span class="status-dot offline"></span>
              <span>Offline</span>
            </div>
            <div class="legend-item">
              <span class="status-dot healthy"></span>
              <span>Healthy</span>
            </div>
            <div class="legend-item">
              <span class="status-dot unsatisfactory"></span>
              <span>Unsatisfactory</span>
            </div>
            <div class="legend-item">
              <span class="status-dot unacceptable"></span>
              <span>Unacceptable</span>
            </div>
            <div class="legend-item" *ngIf="!BHEL_ON_PREM">
              <span class="status-dot service"></span>
              <span>Out for service</span>
            </div>
          </div>

          <mat-icon [class.online]="deviceStatus === 'ONLINE'" [class.offline]="deviceStatus !== 'ONLINE'">
            {{ deviceStatus === 'ONLINE' ? 'wifi' : 'wifi_off' }}
          </mat-icon>
          <div [class.online]="deviceStatus === 'ONLINE'" [class.offline]="deviceStatus !== 'ONLINE'">
            {{ deviceStatus }}
            {{ lastFileTime }}
          </div>
          <div class="pe-3" [matMenuTriggerFor]="menu" style="cursor: pointer;">
            <img style="width: 20px; height: 20px; margin-left: 5px;" src="./assets/settings.png" />
          </div>

          <mat-menu #menu="matMenu" xPosition="before" class="custom-action-menu">
            <!-- <ng-container>
              <button mat-menu-item>
                <mat-icon color="primary">edit</mat-icon>
                <span>Edit</span>
              </button>
            </ng-container> -->

            <ng-container>
              <button mat-menu-item (click)="openSettingsModal()">
                <mat-icon class="text-secondary">settings</mat-icon>
                <span>Settings</span>
              </button>
            </ng-container>

            <ng-container>
              <button mat-menu-item (click)="openPlateDetails()">
                <mat-icon class="text-secondary">info</mat-icon>
                <span>Plate Details</span>
              </button>
            </ng-container>

            <ng-container>
              <button mat-menu-item (click)="openServiceModal()">
                <mat-icon class="text-secondary">settings</mat-icon>
                <span>Service Settings</span>
              </button>
            </ng-container>

            <!-- <ng-container>
              <button mat-menu-item (click)="openAlertSettingsModal()">
                <mat-icon class="text-purple">notifications</mat-icon>
                <span>Alert Settings</span>
              </button>
            </ng-container> -->

            <!-- <div>
              <button mat-menu-item>
                <mat-icon color="warn">delete</mat-icon>
                <span class="text-danger">Delete</span>
              </button>
            </div> -->
          </mat-menu>

        </div>

      </div>

      <div [ngbNavOutlet]="ctdTabset"></div>

    </div>
  </div>
</div>
